export default __webpack_public_path__ + "static/media/pp-girl.ce940a08.webp";